import PropTypes from 'prop-types';
import React, { useState, useEffect, useRef } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import {
  FormGroup,
  TextArea,
  Button,
} from 'carbon-components-react';
import Close16 from '@carbon/icons-react/lib/close/16';
import DateTimePicker from '../../../../helpers/DateTimePicker';

const NewElementTimelineModal = ({modalNewElementVisible, handleNewElementModal, selectedTimeline, editingDisabled, onSubmitElementTimeline}) => {
    const [timelineActive, setTimelineActive] = useState(selectedTimeline);
    const [flagTime, setFlagTime] = useState(false);
    const [, forceUpdate] = useState();

    useEffect(() => {setTimelineActive(selectedTimeline);}, [selectedTimeline]);
    
    const validatorTime = useRef(new SimpleReactValidator({ locale: 'en' }));
    const validator = useRef(new SimpleReactValidator({ locale: 'en' }));
    const validationModal = {
      activity: validator.current.message(
        'activityDescription',
        timelineActive?.activityDescription,
        'required'
      ),
      from: validator.current.message('timeFrom', timelineActive?.timeFrom, 'required'),
    };
    
    const onTimeFromChanged = (inputName, inputValue, objName) => {
      if (inputValue === false ) {
        setFlagTime(true);
        if (!validatorTime.current.allValid()) {
          forceUpdate(1);
        }
      } 
      else {
        setFlagTime(false);
        setTimelineActive(prevState => ({...prevState, timeFrom : inputValue}));
      }
    };

    const onActivityChanged = (event) => {
      event.preventDefault();
      const { value } = event.currentTarget;
      setTimelineActive(prevState => ({...prevState, activityDescription : value}));
    }

    const  onRemarksChanged = (event) => {
      event.preventDefault();
      const { value } = event.currentTarget;
      setTimelineActive(prevState => ({...prevState, remarks : value}));
    }

    const onFormSubmit = (event) => {
      event.preventDefault();
      if (validator.current.allValid()) {
        setFlagTime(false);
        onSubmitElementTimeline(timelineActive);
      }
      else {
        validator.current.showMessages();
        forceUpdate(1);
      }
    }

    const onFormCancel = (event) => {
      event.preventDefault();
      /*
      validator.current.hideMessages();
      forceUpdate(1);
      */
      handleNewElementModal();
    }

    return (


      modalNewElementVisible && (
        <div className="bx--modal bx--modal-tall is-visible">
          <div className="bx--modal-container">
            <div className="bx--modal-header">
              <h3 className="bx--modal-header__heading">Add New Activity</h3>
              <Button
                className="bx--modal-close"
                renderIcon={Close16}
                onClick={(e) => onFormCancel(e)}
                iconDescription="Close Window"
              />
            </div>

            <div className="bx--modal-content information">
              <div className="bx--row">
                
                <div className="bx--col-lg-6 bx--col-md-12">
                  <div className="bx--row">
                    <div className="bx--col-lg-6 bx--col-md-6 paddingTopRow">
                      <FormGroup key="occurrenceTime" legendText="Time From*">
                        <DateTimePicker
                          className="pickerActivity"
                          id="time-pickerFrom"
                          value={timelineActive?.timeFrom || ''}
                          type="time"
                          placeholder="hh:mm AM/PM"
                          name="from"
                          alt="selectedActivity"
                          invalid={validationModal.from != null}
                          onChange={onTimeFromChanged}
                          disabled={false}
                        />
                      </FormGroup>
                    </div>
                    {validationModal.from ?  (
                      <div className="srv-validation-message "> Field required or invalid time format </div>
                    ) : null }
                    {flagTime ? (<div className="srv-validation-message "> Invalid time format </div>) : null}
                  </div>
                </div>
              </div>

              <div className="bx--row">
                <div className="bx--col-md-8 bx--col-lg-6">
                  <FormGroup legendText="Activity Description*">
                    <TextArea
                      maxLength={5000}
                      labelText=""
                      id="inputActivity"
                      cols={150}
                      disabled={editingDisabled}
                      invalid={validationModal.activity != null}
                      invalidText={validator.current.getErrorMessages()['activityDescription']}
                      light
                      placeholder="Input Activity"
                      rows={4}
                      value={timelineActive?.activityDescription || ''}
                      onChange={(e) => onActivityChanged(e)}
                    />
                  </FormGroup>
                </div>
                <div className="bx--col-md-4 bx--col-lg-6">
                  <FormGroup legendText="Remarks">
                    <TextArea
                      maxLength={5000}
                      labelText=""
                      id="inputRemarks"
                      cols={100}
                      disabled={editingDisabled}
                      invalid={false}
                      invalidText={''}
                      light
                      placeholder="Input Remarks"
                      rows={4}
                      value={timelineActive?.remarks || ''}
                      onChange={ (e) => onRemarksChanged(e)}
                    />
                  </FormGroup>
                </div>
              </div>
            </div>
            <div className="bx--modal-footer">
              <Button
                className="button--max-width"
                kind="secondary"
                onClick={(e) => onFormCancel(e)}
              >
                Cancel
              </Button>
              <Button className="button--max-width" kind="primary" onClick={(e) => onFormSubmit(e)}>
                Confirm
              </Button>
            </div>
          </div>
        </div>
      )
    );
  };

  NewElementTimelineModal.propTypes = {
    modalNewElementVisible : PropTypes.bool.isRequired, 
    handleNewElementModal : PropTypes.func.isRequired, 
    selectedTimeline : PropTypes.shape({
      timeFrom : PropTypes.string,
      activityDescription : PropTypes.string,
      remarks : PropTypes.string
    }), 
    editingDisabled: PropTypes.bool.isRequired, 
    onSubmitElementTimeline : PropTypes.func.isRequired
  }

  export default NewElementTimelineModal;